/* istanbul ignore file */
import { Badge, type BadgeProps } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';
import { INVOICE_STATUSES } from '../useInvoiceService';

const MutableInvoiceBadge = (props: BadgeProps) => {
  const { data } = useShowContext();

  if (!data.isInvoiceDocumentWillArriveLater || data.status === INVOICE_STATUSES.REJECTED) {
    return null;
  }

  return (
    <Badge
      sx={{
        ml: 0,
        '&:not(:first-child)': {
          ml: 1,
        },
      }}
      color="primary"
      {...props}
    >
      Can be updated
    </Badge>
  );
};

export default MutableInvoiceBadge;
